import localDB from "./localDB";

let GLOBAL = require('./globals');

const ProductPricesData = {
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}product-prices/${data.product}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}product-price/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}product-price/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
};

export default ProductPricesData;



// WEBPACK FOOTER //
// ./src/data/ProductPricesData.js